import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';
import { useEffect, useState } from 'react';
import { dateFormatter, getCurrentDateTime } from '../../../../../utils';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const styles = StyleSheet.create({
  page: {
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  boldText: {
    fontFamily: 'Roboto',
    fontWeight: 'ultrabold',
    fontSize: '10px'
  },
  text: {
    fontSize: 8,
    marginLeft: 10,
    marginRight: 10
  },
  textUnderlined: {
    fontSize: 8,
    textDecoration: 'underline'
  },
  heading: {
    fontSize: 14,
    fontWeight: 'ultrabold',
    marginBottom: 10,
    textAlign: 'center'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 40,
    marginTop: 6,
    border: '1.2px solid black',
    paddingLeft: 20,
    paddingRight: 70,
    // paddingBottom: 40,
    paddingTop: 5
  },
  column1: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    marginRight: '10%'
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    marginLeft: '5%'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 5
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    padding: 5,
    border: '1px solid black',
    marginTop: 10,
    // backgroundColor: 'navy',
    color: 'black'
  },
  headerText: {
    fontSize: 8,
    fontWeight: 'bold',
    marginLeft: 25,
    marginRight: 25
  },
  columnHeader: {
    width: 'auto'
  },
  columnText: {
    width: '10%',
    textAlign: 'center'
  },
  columnTextWide: {
    width: '17%',
    textAlign: 'center'
  },
  columnTextNarrow: {
    width: '5%',
    textAlign: 'center'
  }
});

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const getCurrentDate = () => {
  const date = new Date();
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const IndoorBillManagementSummaryPdf2 = ({ data }) => {
  console.log(data);
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  const totalSubTotalAmount = data?.indoorService?.reduce((total, item) => total + parseFloat(item.total_amt || 0), 0);
  const totalSubTotalRoomAmount = data?.roomChargeTracker?.reduce(
    (total, item) => total + parseFloat(item.charge || 0),
    0
  );
  const totalRoomCharge = data?.roomChargeTracker?.reduce((total, item) => total + parseFloat(item.net_amt || 0), 0);
  const totalNetAmount = data?.indoorService?.reduce((total, item) => total + parseFloat(item.net_amt || 0), 0);
  const totalDiscountAmt = data?.indoorService?.reduce((total, item) => total + parseFloat(item.disc_amt || 0), 0);
  const addTotalDiscountAmt = data?.indoorService?.reduce(
    (total, item) => total + parseFloat(item.add_discount || 0),
    0
  );
  const addTotalDiscountRoomAmt = data?.roomChargeTracker?.reduce(
    (total, item) => total + parseFloat(item.disc_amt || 0),
    0
  );

  const amountReceivedByIndoorservice = data?.indoorService?.reduce(
    (total, item) => total + parseFloat(item.total_recpt || 0),
    0
  );

  const amountReceivedByReceiptVoucher = data?.receiptVouchers?.reduce(
    (total, item) => total + parseFloat(item.received_amount || 0),
    0
  );

  const amountRefundByRefundVoucher = data?.paymentRefundVouchers?.reduce(
    (total, item) => total + parseFloat(item?.amount || 0),
    0
  );

  const billingDate = formatDate(data?.billing_date);
  const dateTimeToRender = data?.dateTime && data.dateTime !== '-' ? formatDate(data.dateTime) : formatDate(new Date());

  const groupedData = data?.roomChargeTracker.reduce((acc, item) => {
    if (!acc[item.ward_name]) {
      acc[item.ward_name] = {
        ward_name: item.ward_name,
        room_no: item.room_no,
        bed_no: item.bed_no,
        date: item.date,
        Rate: item.charge,
        Disc:item.disc_amt,
        totalQuantity: 0,
        totalNetAmount: 0,
        items: []
      };
    }
    acc[item.ward_name].totalNetAmount += item.net_amt;
    acc[item.ward_name].totalQuantity += 1;
    acc[item.ward_name].items.push(item);
    return acc;
  }, {});
  const groupedDataArray = Object.values(groupedData);

  const allServiceItems = data.indoorService.flatMap((indoorServiceItem) => indoorServiceItem.service_items);
  const groupedServiceItems = allServiceItems.reduce((acc, item) => {
    const group = item.sub_group_name;
    if (!acc[group]) acc[group] = [];
  
    // Find if the same service (doctor + service name) already exists in the group
    const existingItemIndex = acc[group].findIndex(existingItem =>
      existingItem.service_name === item.service_name && existingItem.doctor === item.doctor
    );
  
    if (existingItemIndex === -1) {
      // If service doesn't exist, add the item to the group
      acc[group].push({ ...item });
    } else {
      // If service exists, update the quantity and amount
      const existingItem = acc[group][existingItemIndex];
      existingItem.quantity += item.quantity;
      existingItem.amount += item.amount;
      existingItem.disc_amt += item.disc_amt; // You may also want to add discount if applicable
    }
  
    return acc;
  }, {});
  
  const sortedGroupNames = Object.keys(groupedServiceItems).sort((a, b) => {
    const firstLetterA = a.charAt(0).toLowerCase();
    const firstLetterB = b.charAt(0).toLowerCase();
    return firstLetterA.localeCompare(firstLetterB);
  });

  const formatRegTime = (time) => {
    const [hours, minutes] = time.split(':');
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    // Format to 12-hour time
    const options = { hour: '2-digit', minute: '2-digit', hour12: true };
    return date.toLocaleTimeString('en-US', options);
  };
  
  
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`${data.patientName}'s Final Bill`}>
          <Page size="A4" style={styles.page}>
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{
                width: '100%',
                height: '80px',
                marginBottom: 1,
                marginRight: '5%',
                paddingLeft: '20px',
                marginTop: '2%'
              }}
            />
            <Text
              content={data.billLabel}
              style={{ ...styles.boldText, borderBottom: '1px solid black', fontSize: '18px' }}
            />
            <View style={styles.contentContainer}>
              <View style={styles.column1}>
                <View style={styles.row}>
                  <Text content="UHID NO.           : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.uhid}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Name                 : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.patientName}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Age/Gender      : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.age} / ${data.gender}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Doctor                : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.consultant.doctor}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Department       : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.department}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Address             : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.address}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Ward/Bed No.    : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data?.ward}  /  ${data?.consultantDetail?.bed_no}`} style={{ fontSize: 9 }} />
                </View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Ipd No                       : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.ipd_no}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Bill No.                       " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.finalBillNo || '-'}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Bill Date                    : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={dateTimeToRender} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="Addmission Date     : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${formatDate(data?.admission_date)}/${formatRegTime(data?.admission_time)}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Discharge Date         : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data?.dischargeDate === '-' ? '-' : formatDate(data?.dischargeDate) }/${formatRegTime(data?.dischargeTime)}`}  />
                </View>
                <View style={styles.row}>
                  <Text content="Sponsor                      : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content={`${data.sponsor}`} style={{ fontSize: 9 }} />
                </View>
                <View style={styles.row}>
                  <Text content="TPA/Insurance          : " style={{ fontSize: 9, fontFamily: 'Roboto' }} />
                  <Text content="" style={{ fontSize: 9 }} />
                </View>
              </View>
            </View>
            <View style={{ ...styles.headerContainer, width: '96%' }}>
              <Text
                content="Charge"
                style={{ ...styles.columnTextWide, width: '5%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text content="Head" style={{ ...styles.columnText, width: '5%', fontFamily: 'Roboto', fontSize: 9 }} />
              <Text
                content="Op. Doc"
                style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text
                content="Description"
                style={{ ...styles.columnText, width: '35%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text content="Qty" style={{ ...styles.columnText, width: '5%', fontFamily: 'Roboto', fontSize: 9 }} />
              <Text content="Rate" style={{ ...styles.columnText, width: '5%', fontFamily: 'Roboto', fontSize: 9 }} />
              <Text content="Dis" style={{ ...styles.columnText, width: '5%', fontFamily: 'Roboto', fontSize: 9 }} />
              <Text
                content="Amount"
                style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto', fontSize: 9 }}
              />
            </View>
            {sortedGroupNames.map((groupName, groupIndex) => (
  <>
    <Text
      style={{
        ...styles.columnText,
        width: '90%',
        textAlign: 'start',
        fontSize: '10px',
        marginBottom: '2%',
        fontFamily: 'Roboto',
        marginTop: '1%',
      }}
      content={groupName}
    />
    {groupedServiceItems[groupName].map((serviceItem, serviceIndex) => (
      <View
        style={{
          ...styles.row,
          padding: '5px',
          marginBottom: '0.5%',
          backgroundColor: serviceIndex % 2 !== 0 ? 'white' : '#e0e0e0',
          width: '95%',
        }}
        key={`${groupIndex}-${serviceIndex}`}
      >
        <Text
          style={{ ...styles.columnTextWide, width: '10%', fontSize: 9 }}
          content={formatDate(serviceItem.billingDate)}
        />
        <Text
          style={{ ...styles.columnTextWide, width: '20%', fontSize: 9 }}
          content={serviceItem.doctor}
        />
        <Text
          style={{ ...styles.columnTextWide, width: '35%', fontSize: 9 }}
          content={serviceItem.service_name}
        />
        <Text style={{ ...styles.columnText, width: '5%', fontSize: 9 }} content={serviceItem.quantity} />
        <Text style={{ ...styles.columnText, width: '5%', fontSize: 9 }} content={serviceItem.rate} />
        <Text style={{ ...styles.columnText, width: '5%', fontSize: 9 }} content={serviceItem.disc_amt} />
        <Text style={{ ...styles.columnText, width: '5%', fontSize: 9 }} content={serviceItem.amount} />
      </View>
    ))}
    <View style={{ ...styles.row, padding: '5px', marginLeft: '61%' }}>
      <Text
        style={{ ...styles.columnTextWide, width: '50%', fontFamily: 'Roboto' }}
        content={'Sub Total'}
      />
      <Text
        style={{ ...styles.columnTextWide, width: '10%', fontFamily: 'Roboto' }}
        content={groupedServiceItems[groupName].reduce(
          (sum, item) => sum + parseFloat(item.amount),
          0
        )}
      />
    </View>
  </>
))}
            {groupedDataArray.map((group, index) => (
              <>
                <Text
                  content={'Room Charges'}
                  style={{
                    ...styles.columnText,
                    width: '90%',
                    textAlign: 'start',
                    fontFamily: 'Roboto',
                    fontSize: '10px',
                    marginTop: '1%'
                  }}
                />
                <View
                  key={index}
                  style={{ ...styles.row, marginTop: 10, padding: '5px', width: '92%', backgroundColor: '#e0e0e0' }}
                >
                    <Text
                    content={`Bed Charge`}
                    style={{ ...styles.columnText, width: '10%', fontSize: 9 }}
                  />
                  <Text
                    content={`${group.ward_name}/${group.room_no}/${group.bed_no}`}
                    style={{ ...styles.columnText, width: '20%', fontSize: 9 }}
                  />
                  <Text content={""} style={{ ...styles.columnText, width: '28%', fontSize: 9 }} />
                  <Text content={group.Rate} style={{ ...styles.columnText, width: '5%', fontSize: 9 }} />
                  <Text content={group.totalQuantity} style={{ ...styles.columnText, width: '5%', fontSize: 9 }} />
                  <Text content={group.Disc} style={{ ...styles.columnText, width: '5%', fontSize: 9 }} />
                  <Text content={group.totalNetAmount} style={{ ...styles.columnText, width: '5%', fontSize: 9 }} />
                </View>
                <View key={index} style={{ ...styles.row, marginTop: 10, marginLeft: '73%' }}>
                  <Text content={`Sub Total`} style={{ ...styles.columnText, width: '30%', fontFamily: 'Roboto' }} />
                  <Text
                    content={group.totalNetAmount}
                    style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }}
                  />
                </View>
              </>
            ))}

            <View style={{ width: '100%', marginLeft: '20%', marginTop: '2%' }}>
              <View style={{ ...styles.row }}>
                <Text
                  content="Grand Total                  :-"
                  style={{
                    ...styles.columnTextWide,
                    fontWeight: 'bold',
                    marginLeft: '56%',
                    fontFamily: 'Roboto',
                    textAlign: 'start'
                  }}
                />
                <Text
                  content={`${totalSubTotalAmount + totalSubTotalRoomAmount}`}
                  style={{ ...styles.columnText, fontFamily: 'Roboto' }}
                />
              </View>
              <View style={{ ...styles.row }}>
                <Text
                  content="Discount                       :-"
                  style={{
                    ...styles.columnTextWide,
                    fontWeight: 'bold',
                    marginLeft: '56%',
                    fontFamily: 'Roboto',
                    textAlign: 'start'
                  }}
                />
                <Text
                  content={`${totalDiscountAmt + addTotalDiscountAmt + addTotalDiscountRoomAmt}`}
                  style={{ ...styles.columnText, fontFamily: 'Roboto' }}
                />
              </View>
              <View style={{ ...styles.row }}>
                <Text
                  content="Net Bill Amount           :-"
                  style={{
                    ...styles.columnTextWide,
                    fontWeight: 'bold',
                    marginLeft: '56%',
                    fontFamily: 'Roboto',
                    textAlign: 'start'
                  }}
                />
                <Text
                  content={`${totalRoomCharge + totalNetAmount}`}
                  style={{ ...styles.columnText, fontFamily: 'Roboto' }}
                />
              </View>
              <View style={{ ...styles.row }}>
                <Text
                  content="Amount Received        :-"
                  style={{
                    ...styles.columnTextWide,
                    fontWeight: 'bold',
                    marginLeft: '56%',
                    fontFamily: 'Roboto',
                    textAlign: 'start'
                  }}
                />
                <Text
                  content={`${amountReceivedByIndoorservice + amountReceivedByReceiptVoucher}`}
                  style={{ ...styles.columnText, fontFamily: 'Roboto' }}
                />
              </View>
              <View style={{ ...styles.row }}>
                <Text
                  content="Balance                         :-"
                  style={{
                    ...styles.columnTextWide,
                    fontWeight: 'bold',
                    marginLeft: '56%',
                    fontFamily: 'Roboto',
                    textAlign: 'start'
                  }}
                />
                <Text
                  content={
                    totalSubTotalAmount + totalSubTotalRoomAmount +
                    amountRefundByRefundVoucher -
                    (amountReceivedByIndoorservice +
                      amountReceivedByReceiptVoucher +
                      totalDiscountAmt +
                      addTotalDiscountAmt +
                      addTotalDiscountRoomAmt)
                  }
                  style={{ ...styles.columnText, fontFamily: 'Roboto' }}
                />
              </View>
            </View>

            <Text content="Reciept Voucher" style={{ ...styles.columnTextWide, fontFamily: 'Roboto' }} />
            <View style={{ ...styles.headerContainer, width: '92%' }}>
              <Text
                content="S No."
                style={{ ...styles.columnTextNarrow, width: '10%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text
                content="Date"
                style={{ ...styles.columnTextNarrow, width: '10%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text
                content="IPD No."
                style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text
                content="Payment Mode"
                style={{ ...styles.columnTextWide, width: '25%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text
                content="Receipt No."
                style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text
                content="Payment Type"
                style={{ ...styles.columnText, width: '17%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text
                content="Received Amount"
                style={{ ...styles.columnText, width: '30%', fontFamily: 'Roboto', fontSize: 9 }}
              />
            </View>

            {data.receiptVouchers && data.receiptVouchers.length > 0 ? (
              data.receiptVouchers.map((voucher, index) => (
                <View
                  style={{
                    ...styles.row,
                    backgroundColor: index % 2 !== 0 ? '#ffffff' : '#e0e0e0',
                    marginTop: 5,
                    width: '92%',
                    padding:"5px"
                  }}
                  key={voucher._id}
                >
                  <Text content={index + 1} style={{ ...styles.columnTextNarrow, width: '10%' }} />
                  <Text
                    content={`${formatDate(voucher?.date)} ${voucher?.time}`}
                    style={{ ...styles.columnTextNarrow, width: '15%' }}
                  />
                  <Text content={data.ipd_no || '-'} style={{ ...styles.columnText, width: '10%' }} />
                  <Text content={voucher.payment_mode || '-'} style={{ ...styles.columnTextWide, width: '25%' }} />
                  <Text content={voucher.receipt_no || '-'} style={{ ...styles.columnText, width: '15%' }} />
                  <Text content={voucher.payment_type || '-'} style={{ ...styles.columnText, width: '15%' }} />
                  <Text content={voucher.received_amount || '0'} style={{ ...styles.columnText, width: '30%' }} />
                </View>
              ))
            ) : (
              <View style={{ ...styles.row }}>
                <Text content="No receipts found" style={{ ...styles.columnTextNarrow, width: '100%' }} />
                <Text content="-" style={styles.columnText} />
                <Text content="-" style={styles.columnTextWide} />
                <Text content="-" style={styles.columnText} />
                <Text content="-" style={{ ...styles.columnText, width: '20%' }} />
              </View>
            )}
            <Text
              content="Refund Voucher"
              style={{ ...styles.columnTextWide, marginTop: '5%', fontFamily: 'Roboto' }}
            />
            <View style={{ ...styles.headerContainer, width: '92%' }}>
              <Text
                content="Sr No."
                style={{ ...styles.columnTextNarrow, width: '10%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text
                content="Date"
                style={{ ...styles.columnTextNarrow, width: '10%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text
                content="IPD No."
                style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text
                content="Payment Mode"
                style={{ ...styles.columnTextWide, width: '25%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text
                content="Reciept No."
                style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text
                content="Payment Type"
                style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto', fontSize: 9 }}
              />
              <Text
                content="Amount"
                style={{ ...styles.columnText, width: '30%', fontFamily: 'Roboto', fontSize: 9 }}
              />
            </View>

            {data.paymentRefundVouchers && data.paymentRefundVouchers.length > 0 ? (
              data.paymentRefundVouchers.map((voucher, index) => (
                <View
                  style={{
                    ...styles.row,
                    backgroundColor: index % 2 !== 0 ? '#ffffff' : '#e0e0e0',
                    marginTop: 5,
                    width: '92%',
                   padding:"5px"
                  }}
                  key={voucher._id}
                >
                  <Text content={index + 1} style={{ ...styles.columnTextNarrow, width: '10%', fontSize: 9 }} />
                  <Text
                    content={`${formatDate(voucher?.date)} ${voucher?.time}`}
                    style={{ ...styles.columnTextNarrow, width: '15%', fontSize: 9 }}
                  />
                  <Text content={data.ipd_no || '-'} style={{ ...styles.columnText, width: '10%', fontSize: 9 }} />
                  <Text
                    content={voucher.payment_mode || '-'}
                    style={{ ...styles.columnTextWide, width: '25%', fontSize: 9 }}
                  />
                  <Text content={voucher.doc_no || '-'} style={{ ...styles.columnText, width: '15%', fontSize: 9 }} />
                  <Text
                    content={voucher.payment_type || '-'}
                    style={{ ...styles.columnText, width: '15%', fontSize: 9 }}
                  />
                  <Text content={voucher.amount || '0'} style={{ ...styles.columnText, width: '30%', fontSize: 9 }} />
                </View>
              ))
            ) : (
              <View style={{ ...styles.row }}>
                <Text content="No Refund  Found" style={{ ...styles.columnTextNarrow, width: '100%' }} />
                <Text content="-" style={styles.columnText} />
                <Text content="-" style={styles.columnTextWide} />
                <Text content="-" style={styles.columnText} />
                <Text content="-" style={{ ...styles.columnText, width: '20%' }} />
              </View>
            )}

            <View style={{ ...styles.row, marginTop: '15%' }}>
              <Text
                content="Authorized Signatory"
                style={{ ...styles.columnTextWide, fontWeight: 'bold', marginLeft: '65%' }}
              />
              <Text content="" style={{ ...styles.columnText }} />
            </View>
            <View style={{ ...styles.row, marginTop: '0' }}>
              <Text content="Patient/Attendent Signatory:" style={{ fontWeight: 'bold', marginRight: '60%' }} />
            </View>
            <View style={{ ...styles.row, marginTop: '2%' }}>
              <Text content="Relation With Patient:" style={{ fontWeight: 'bold', marginRight: '60%' }} />
            </View>
            <View style={{ ...styles.row, marginTop: '2%' }}>
              <Text content="Mobile No.:" style={{ fontWeight: 'bold', marginRight: '60%' }} />
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};
